import { render, staticRenderFns } from "./GalleryPost.vue?vue&type=template&id=1ecc730c&scoped=true"
import script from "./GalleryPost.vue?vue&type=script&lang=js"
export * from "./GalleryPost.vue?vue&type=script&lang=js"
import style0 from "./GalleryPost.vue?vue&type=style&index=0&id=1ecc730c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc730c",
  null
  
)

export default component.exports